var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hide
    ? _c(
        "div",
        {
          staticClass: "input-field-npv",
          style: {
            width: _vm.inputFieldSize + "%",
            paddingBottom: _vm.inputType === "group" ? 0 : "4px"
          },
          attrs: {
            "data-variable-name": _vm.variableName,
            "data-list-name": _vm.selectOptions
          }
        },
        [
          _vm.inputType === "group"
            ? [
                _c(
                  "label",
                  {
                    staticClass: "group-label",
                    staticStyle: { "margin-bottom": "10px" }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
                ),
                _vm._v(" "),
                _c("v-divider")
              ]
            : _vm.label !== ""
            ? _c(
                "label",
                {
                  staticClass: "form-label-div labelInputNPV",
                  class: { disabled: _vm.disabled },
                  staticStyle: { "margin-bottom": "6px" }
                },
                [
                  _vm._v("\n    " + _vm._s(_vm.label) + " "),
                  _vm.required ? _c("span", [_vm._v("*")]) : _vm._e(),
                  _vm.badLabel
                    ? _c("span", { staticClass: "errorLabel" }, [
                        _vm._v("Limit is: " + _vm._s(_vm.limit) + " ")
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "row" } },
            [
              _vm.inputType === "text"
                ? _c("InputTypeTextNPV", {
                    attrs: {
                      value: _vm.value,
                      disabled:
                        _vm.disabled ||
                        (_vm.labelIsLocked &&
                          _vm.variableName.includes("_label")),
                      placeholder: _vm.placeholder,
                      "automatic-label": _vm.automaticLabel,
                      "var-name": _vm.variableName,
                      restrictSpecialCharacters: _vm.restrictSpecialCharacters,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      "check-alphanumeric": _vm.checkAlphanumeric,
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      },
                      generateLabel: function($event) {
                        return _vm.$emit("generateLabel")
                      }
                    }
                  })
                : _vm.inputType === "number" ||
                  _vm.inputType === "int" ||
                  _vm.inputType === "integer" ||
                  _vm.inputType === "float" ||
                  _vm.inputType === "int_pos" ||
                  _vm.inputType === "float_pos" ||
                  _vm.inputType === "number_pos"
                ? _c("InputTypeNumberNPV", {
                    attrs: {
                      value: _vm.value,
                      disabled: _vm.disabled,
                      placeholder: _vm.placeholder,
                      min: _vm.minValue,
                      max: _vm.max,
                      step: _vm.step,
                      onkeyDown: _vm.onKeyDown,
                      "input-type": _vm.inputType,
                      "var-name": _vm.variableName
                    },
                    on: {
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      }
                    }
                  })
                : _vm.inputType === "email"
                ? _c("InputTypeEmailNPV", {
                    attrs: {
                      value: _vm.value,
                      disabled: _vm.disabled,
                      placeholder: _vm.placeholder,
                      "var-name": _vm.variableName,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      }
                    }
                  })
                : _vm.inputType === "textarea"
                ? _c("InputTypeTextAreaNPV", {
                    attrs: {
                      value: _vm.value,
                      disabled: _vm.disabled,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      }
                    }
                  })
                : _vm.inputType === "select" ||
                  _vm.inputType === "multi-select" ||
                  _vm.inputType === "multiselect"
                ? _c("InputTypeTreeSelectNPV", {
                    attrs: {
                      value: _vm.value,
                      "select-options": _vm.selectOptions,
                      multiple:
                        _vm.inputType === "multi-select" ||
                        _vm.inputType === "multiselect",
                      placeholder: _vm.selectPlaceholder,
                      disabled: _vm.disabled,
                      clearable: _vm.clearable,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      }
                    }
                  })
                : _vm.inputType === "user"
                ? _c("InputTypeTreeSelectUserNPV", {
                    attrs: {
                      value: _vm.value,
                      placeholder: _vm.selectPlaceholder,
                      disabled: _vm.disabled,
                      clearable: _vm.clearable,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      }
                    }
                  })
                : _vm.inputType === "radio"
                ? _c("InputTypeRadioNPV", {
                    attrs: {
                      value: _vm.value,
                      disabled: _vm.disabled,
                      "radio-in-column": _vm.radioInColumn,
                      "radio-options": _vm.radioOptions,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      }
                    }
                  })
                : _vm.inputType === "url"
                ? _c("InputTypeUrlNPV", {
                    attrs: {
                      value: _vm.value,
                      disabled: _vm.disabled,
                      placeholder: _vm.placeholder,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      }
                    }
                  })
                : _vm.inputType === "date"
                ? _c("InputTypeDateNPV", {
                    attrs: {
                      value: _vm.value,
                      disabled: _vm.disabled,
                      required: _vm.required,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      }
                    }
                  })
                : _vm.inputType === "datetime"
                ? _c("InputTypeDateTimeNPV", {
                    staticStyle: { "max-width": "100%", width: "100%" },
                    attrs: {
                      type: "datetime-local",
                      value: _vm.value,
                      disabled: _vm.disabled,
                      min: _vm.min,
                      max: _vm.max,
                      step: _vm.step,
                      required: _vm.required,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      updateValue: function($event) {
                        return _vm.updateValue($event)
                      }
                    }
                  })
                : _vm.inputType === "checkbox"
                ? _c("InputTypeCheckBoxNPV", {
                    attrs: {
                      value: _vm.value,
                      "var-name": _vm.variableName,
                      "object-data": _vm.objectData,
                      "checkbox-options": _vm.checkboxOptions,
                      disabled: _vm.disabled,
                      "required-fail": _vm.requiredFail
                    },
                    on: {
                      change: function($event) {
                        return _vm.updateCheckboxValue($event)
                      }
                    }
                  })
                : _vm.inputType === "photo"
                ? _c("InputTypePhotoNPV", {
                    attrs: {
                      disabled: _vm.disabled,
                      value: _vm.value,
                      label: _vm.label,
                      "var-name": _vm.variableName
                    },
                    on: {
                      change: function($event) {
                        return _vm.updateValue($event)
                      },
                      removePhoto: function($event) {
                        return _vm.$emit("removePhoto", $event)
                      }
                    }
                  })
                : _vm.inputType === "other"
                ? _c(
                    "div",
                    {
                      staticClass: "input-container",
                      class: { "required-fail": _vm.requiredFail },
                      attrs: { disabled: _vm.disabled }
                    },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.fieldIsLabel
                ? _c(
                    "v-icon",
                    {
                      staticStyle: { color: "var(--v-accent-base)" },
                      attrs: { disabled: _vm.userCanUnlockLabel },
                      on: {
                        click: function($event) {
                          return _vm.$emit("toggle-label-lock")
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.labelIsLocked ? "mdi-lock" : "mdi-lock-open")
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60832814", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60832814","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/InputFieldsNPV.vue
// module id = null
// module chunks = 